import { TApi } from '@/types/interface';
import { requestPostToFormData } from '@/utils/request';

export async function apiGetUrlTitle(urlString: string): Promise<string> {
  const res = await fetch(`/knowhow/api/oss/url/title?urlString=${urlString}`, {
    method: 'GET',
    headers: {
      contentType: 'text/plain',
    },
  });
  return res.text();
}

export async function apiGetCompleteOssUrl(path: string): Promise<string> {
  // return requestPost(`/api/oss/view/url`, path);
  const res = await fetch(`/knowhow/api/oss/view/url`, {
    method: 'POST',
    headers: {
      contentType: 'text/plain',
    },
    body: path,
  });
  return res.text();
}

// 粘贴图片时时上传图片
export async function apiUploadImgByUrl(url: string): Promise<TApi<string>> {
  const res = await fetch(`/knowhow/api/oss/upload/image/url`, {
    method: 'POST',
    headers: {
      contentType: 'text/plain',
    },
    body: url,
  });
  return res.json();
}
export async function apiOssByUrl(url: string): Promise<TApi<string>> {
  const res = await fetch(`/api/oss`, {
    method: 'POST',
    headers: {
      contentType: 'text/plain',
    },
    body: url,
  });
  return res.json();
}

// 上传图片
export async function apiUploadImg(path: string, file: any): Promise<TApi<string>> {
  return requestPostToFormData('/v2/camp/api/oss/upload', { path, file });
}
